/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VehicleStateEnum {
	DISPONIBILE = 'DISPONIBILE',
	OPZIONATO = 'OPZIONATO',
	OSCURATO = 'OSCURATO',
	VENDUTO = 'VENDUTO',
}

export enum VehcileAvailabilityEnum {
	TARGATO = 'TARGATO',
	TELAIATO = 'TELAIATO',
	IN_ARRIVO = 'IN_ARRIVO',
	ORDINATO = 'ORDINATO',
}

export enum RoleEnum {
	ADMIN = 'ADMIN',
	BACKOFFICE = 'BACKOFFICE',
	SALES = 'SALES',
	SALES_INTERNAL = 'SALES_INTERNAL',
	SALES_DEALER = 'SALES_DEALER',
	SEGNALATORE = 'SEGNALATORE',
	MASTER = 'MASTER',
	FLEET_MANAGER = 'FLEET_MANAGER',
	AREA_MANAGER = 'AREA_MANAGER',
}

export enum HistoryActionTypeEnum {
	DISPONIBILE = 'DISPONIBILE',
	OPZIONAMENTO = 'OPZIONAMENTO',
	OPZIONAMENTO_CANCELLATO = 'OPZIONAMENTO_CANCELLATO',
	OPZIONAMENTO_RINNOVATO = 'OPZIONAMENTO_RINNOVATO',
	OPZIONAMENTO_SCADUTO = 'OPZIONAMENTO_SCADUTO',
	OSCURAMENTO = 'OSCURAMENTO',
	OSCURAMENTO_RINNOVATO = 'OSCURAMENTO_RINNOVATO',
	OSCURAMENTO_CANCELLATO = 'OSCURAMENTO_CANCELLATO',
	VENDITA = 'VENDITA',
}

export enum InformationServicesListEnum {
	MANUTEZIONE = 'Manutenzione',
	GOMME = 'Gomme',
	RCA = 'RCA',
	I_F = 'I/F',
	KASCO = 'Kasco',
	VETTURA = 'Vettura sostitutiva',
}

export enum AreaObjectTypeEnum {
	FILE = 'file',
	VIDEO_URL = 'video_url',
	FOLDER = 'folder',
}

export enum OpportunityStageEnum {
	waiting_sign = 'Attesa firma',
	proposal = 'Proposal',
	qualification = 'Qualification',
	closed_won = 'Closed Won',
	closed_by_customer = 'Chiusa persa per ripensamento cliente',
	closed_by_credit_score_check = 'Chiusa persa per credito',
	credit_score_check = 'Al credito',
	suspended = 'Sospesa',
	negotiation = 'Negotiation',
}

// Pud Status id in doce point 9 https://docs.google.com/document/d/1AYDzsK5jat8TeOeRaizbF5w3FSfFN2-N/edit#heading=h.z337ya
export enum PudStatusId {
	IN_ATTESA = '1',
	CONFERMATA = '2',
	ANNULLATA = '3',
}

// Pud pickup and delivery state in doc point 2.1 https://docs.google.com/document/d/1AYDzsK5jat8TeOeRaizbF5w3FSfFN2-N/edit#heading=h.z337ya

export enum PudPickupState {
	DA_PROGRAMMARE = 'Da programmare',
	DA_RITIRARE = 'Da ritirare',
	RITIRATA = 'Ritirata',
}

export enum PudDeliveryState {
	DA_PROGRAMMARE = 'Da programmare',
	DA_RICONSEGNARE = 'Da riconsegnare',
	RICONSEGNATA = 'Riconsegnata',
}
export enum VisibilityTagEnum {
	MASERATI = 'MASERATI',
	MULTIBRAND = 'MULTIBRAND',
	VOLKSWAGEN = 'VOLKSWAGEN',
	STELLANTIS = 'STELLANTIS',
	FACILE = 'FACILE',
}

export enum DriveItEasyStatusEnum {
	ATTIVO = 'Attivo',
	SOSPESO = 'Sospeso',
}

export enum MarketsEnum {
	it = 'it',
	es = 'es',
}

export enum RecordTypeEnum {
	Azienda = '0125I000000PpzmQAC',
	Libero_Professionista = '012SX0000002F7pYAE',
	Privato = '0125I000000Pq30QAC',
}

export enum ClienteEnum {
	Azienda = 'Azienda con partita IVA',
	Libero_Professionista = 'Libero professionista',
	Privato = 'Privato',
}

export enum OpportunityPageTabsEnum {
	DETAILS = 'details',
	DOCUMENTS = 'documents',
}

export enum OpportunityCreditStatusEnum {
	credit_awaiting_docs = 'credit_awaiting_docs',
	credit_sent = 'credit_sent',
	credit_approved = 'credit_approved',
	credit_approved_conditionally = 'credit_approved_conditionally',
	credit_rejected = 'credit_rejected',
	credit_suspended = 'credit_suspended',
	closed_won = 'closed_won',
}

export enum TabsEnum {
  NEW_LEADS = "NEW_LEADS",
  NURTURE_LEADS = "NURTURE_LEADS",
  QUOTED = "QUOTED",
  UNQUALIFIED_LEADS = "UNQUALIFIED_LEAS",
  TO_BE_CONVERTED = "TO_BE_CONVERTED",
}

export enum LeadsModalModeEnum {
	DETAILS = 'details',
	ASSIGN_SALE = 'assign_sale',
	CREATE_NEW_LEAD = 'create_new_lead',
	NONE = 'none',
	PHONE_CALL_NO_REPLY = 'phone_call_no_reply',
	PHONE_CALL_WITH_REPLY = 'phone_call_with_reply',
	QUALIFIED = 'qualified',
	UNQUALIFIED = 'unqualified',
	QUOTED = 'quoted',
}

export enum LeadsWizardActiveStepEnum {
  ACCOUNT = "account",
  OPPORTUNITY = "opportunity",
  VEHICLE = "vehicle",
  SEND_QUOTE = "send_quote",
}

export enum LeadStatusEnum {
	UNQUALIFIED = 'Unqualified',
	NEW = 'New',
	QUALIFIED = 'Qualified',
	QUOTED = 'Quoted',
	NURTURING = 'Nurturing',
	WORKING = 'Working',
	FULL = 'Full',
}

export enum LeadSourceItalyEnum {
	CAR_PLANNER = 'CarPlanner',
	OTHER = 'Other',
	LEASYS_ITALIA = 'Leasys Italia',
	DIALOGO = 'Dialogo',
	CONTATTO = 'Contatto',
	CAR_AFFINITY = "CarAfinity'",
	FACILE = 'Facile',
	CAR_X = 'CarX',
	STORE = 'Store',
	SITO_WEB = 'Sito Web',
	COMPANEO = 'Companeo',
	CONTATTO_PERSONALE = 'Contatto personale',
}

export enum LeadChanelEnum {
	IG = 'ig',
	LINKEDIN = 'linkedin.com',
	FB = 'fb',
	L_INSTAGRAM = 'l.instagram.com',
	GOOGLE = 'google',
	TIK_TOK = 'tik tok',
}

export enum CountryEnum {
	IT = 'IT',
	ES = 'ES',
}

export enum LeadMotivationEnum {
	WRONG_CONTACTS = 'Contatti errati',
	NOT_INTERESTED = "Non interessato all'offerta",
	UNAWARE = 'Non sa di aver lasciato la richiesta',
	WRONG_ASSUMPTION = 'Pensava si trattasse di altro (es noleggio breve)',
	NO_REPLY = 'Non risponde',
	IS_POOR = 'Interessato ma non ha i requisiti per contratto NLT',
}

export enum LeadCallResponseEnum {
	ANSWERED_INTERESTED = 'RISPOSTA_INTERESSATO',
	ANSWERED_NOT_INTERESTED = 'RISPOSTA_NON_INTERESSATO',
	NO_ANSWER = 'NON_RISPOSTA',
}

export enum LeadReminderStatusEnum {
  PENDING = "PENDING",
  SENT = "SENT",
  DELETED = "DELETED",
  FAILED = "FAILED",
}

export enum ReporterStatusEnum {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
	UNKNOWN = "UNKNOWN"
}

export enum StellantisQuoteStatus {
  PENDING = "PENDING",
	IN_PROGRESS = "IN_PROGRESS",
	QUOTED = "QUOTED",
	UNQUOTABLE = "UNQUOTABLE",
	UNKNOWN = "UNKNOWN",
}

export enum UserGroup {
	CAN_APPROVE_SEGNALATORI = "CAN_APPROVE_SEGNALATORI",
}
